import React from "react"
import {InjectIntl, injectIntl, getMessage} from "@irati/utils/lang"
import {Row, Col} from "../Layout"
import {SpacingProps} from "../Spacing"
import Label from "../FormItem/styled/Label"

type SizeRatio = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12

interface Props extends InjectIntl {
  size?: {
    /* bootstrap col size */
    left?: SizeRatio
    /* bootstrap col size */
    right?: SizeRatio
    /* padding between the two elements */
    spaceBetween?: SpacingProps["paddingLeft"] | SpacingProps["paddingRight"]
  }
  /* component on the left */
  left: any
  /* component on the right */
  right: any
  label: string
  hideLabel?: boolean
}

const DoubleInputRow: React.FC<Props> = ({label, hideLabel, size, left, right, formatMessage}) => {
  return (
    <Row>
      <Col hidden={hideLabel} xs={12}>
        {label && <Label flush>{getMessage(formatMessage, label)}</Label>}
      </Col>
      <Col xs={size?.left || 8} paddingRight={size?.spaceBetween || 2}>
        {left}
      </Col>
      <Col xs={size?.right || 4} paddingLeft={size?.spaceBetween || 2}>
        {right}
      </Col>
    </Row>
  )
}

export default injectIntl(DoubleInputRow)
